import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import {
    fieldsGlassWallClosingTypes,
    fieldsGlassWallDimension, fieldsGlassWallFrameMaterial, fieldsGlassWallOptions, fieldsGlassWallStyle, fieldsGlassWallWindowMaterial,
} from './common/fieldsGlassWalls';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const glassWallForm: IForm = {
    formId       : PublishedFormId.GlassWall,
    type         : FormTypeId.GlassWall,
    thumbnailURL : '/resized-images/forms/glassWall.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.WindowMaterial,
        IFormFieldKey.FrameMaterial,
        IFormFieldKey.Dimension,
        IFormFieldKey.GlassWallStyle,
        IFormFieldKey.Openings,
        IFormFieldKey.ClosingType,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        windowMaterial : fieldsGlassWallWindowMaterial,
        frameMaterial  : fieldsGlassWallFrameMaterial,
        dimension      : fieldsGlassWallDimension,
        glassWallStyle : fieldsGlassWallStyle,
        openings       : fieldsGlassWallOptions,
        closingType    : fieldsGlassWallClosingTypes,
        additionalData : additionalDataFactory({
            budgetMin          : 500,
            budgetMax          : 30000,
            budgetDefaultValue : 4000,
            marks              : budgetMarksBuilder(500, 250, 10000, 1000, 30000),
        }),
        contact: fieldsContact,
    },
};

export default glassWallForm;
